import React from 'react';
import { reportError } from '@/services/bugsnag';
import { ErrorFallback } from '@/components/ErrorModal/ErrorFallback';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    const normalizedError = error instanceof Error ? error : new Error(String(error));
    reportError({ error: normalizedError });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}
